"use client";

import { notFound } from "next/navigation";
import { useEffect, useState } from "react";
import LoadingUI from "~/src/components/common/LoadingUI";
import AnalysisDetails from "~/src/components/feature/analysis/info/AnalysisDetails";
import { readDraft } from "~/src/lib/firestore/draft";
import { useAuthContext } from "~/src/stores/context/auth/AuthContext";
import { AnalysisArticle } from "~/src/type/ui/article/article";

type DraftPreviewProps = {
  docId: string;
};

/**
 * 下書き記事プレビュー
 *   本人のみ閲覧可能なため、SEO対象外としてクライアントサイドで完結させる
 */
export default function DraftPreview({ docId }: DraftPreviewProps) {
  const { user, info } = useAuthContext();
  const [article, setArticle] = useState<AnalysisArticle | undefined | null>(undefined);

  useEffect(() => {
    // 遷移元によっては、スクロール途中になることがあるため
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // 認証状態解決前は待機
    if (user === undefined) {
      return;
    }

    // 未ログインは下書き閲覧不可
    if (user === null) {
      setArticle(null);
      return;
    }

    (async () => {
      try {
        const result = await readDraft(user.uid, docId);
        setArticle(result ?? null);
      } catch (error) {
        console.log("DraftPreview fetch error=", error);
        setArticle(null);
      }
    })();
  }, [user, docId]);

  if (article === null) {
    notFound();
  }

  if (!article) {
    return <LoadingUI />;
  }

  const liked = user && info ? info.favoritList.includes(docId) : false;

  return (
    <div className="bg-WHITE_2">
      <div className="mx-auto min-h-screen max-w-256 py-4 md:pt-6">
        <AnalysisDetails
          analysisId={docId}
          contents={article.contents}
          graph={article.graph}
          analysisTime={{ create: article.contents.draftUpdatedAt, update: undefined }}
          liked={liked}
        />
      </div>
    </div>
  );
}
